import React from "react";
const SvgBBiconsFiltr = props => (
    <svg viewBox="0 0 200 200" {...props}>
        <g id="Obecné_ikony" data-name="Obecné ikony">
            <path d="M53.53,115.37V45.54a5.34,5.34,0,0,0-10.68,0v69.83a19.68,19.68,0,0,0,0,37.89v1.2a5.34,5.34,0,0,0,10.68,0v-1.2a19.68,19.68,0,0,0,0-37.89Zm-5.34,28a9,9,0,1,1,9-9A9,9,0,0,1,48.19,143.34Z"/>
            <path d="M105.34,46.9V45.54a5.34,5.34,0,0,0-10.68,0V46.9a19.68,19.68,0,0,0,0,37.89v69.67a5.34,5.34,0,0,0,10.68,0V84.79a19.68,19.68,0,0,0,0-37.89Zm-5.34,28a9,9,0,1,1,9-9A9,9,0,0,1,100,74.88Z"/>
            <path d="M171.51,112.64a19.72,19.72,0,0,0-14.36-19V45.54a5.34,5.34,0,1,0-10.67,0V93.69a19.67,19.67,0,0,0,0,37.89v22.88a5.34,5.34,0,1,0,10.67,0V131.58A19.72,19.72,0,0,0,171.51,112.64Zm-19.7,9a9,9,0,1,1,9-9A9,9,0,0,1,151.81,121.66Z"/>
        </g>
    </svg>
);

export default SvgBBiconsFiltr;